export default function HeroSection() {
  return (
    <section className="relative w-full h-screen min-h-[600px] flex flex-col items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url(https://readdy.ai/api/search-image?query=Minimalist%20fashion%20lifestyle%20flat%20lay%20with%20sneakers%20hoodie%20and%20accessories%20on%20warm%20cream%20textured%20surface%2C%20soft%20natural%20daylight%20from%20window%2C%20editorial%20photography%20with%20gentle%20shadows%2C%20elegant%20minimal%20composition%2C%20warm%20neutral%20tones%2C%20organic%20textures%20visible&width=1800&height=1200&seq=hero-bg-main-003&orientation=landscape)",
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/40"></div>

      <div className="relative z-10 w-full text-center px-6 md:px-10 flex flex-col items-center">
        <p className="text-xs tracking-[0.2em] uppercase text-background-50/80 mb-6 font-label">
          Curated Product Directory
        </p>

        <h1 className="text-3xl md:text-5xl lg:text-6xl text-background-50 font-heading leading-tight max-w-4xl">
          Pandabuyspreadsheet — The Ultimate
          <br />
          <span className="text-primary-200">Curated Product</span> Spreadsheet Hub
        </h1>

        <p className="mt-5 text-sm md:text-base text-background-50/80 max-w-xl leading-relaxed">
          Discover the most updated pandabuyspreadsheet collections with curated fashion,
          shoes, and lifestyle finds — all organized for fast browsing and smarter decisions.
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-center gap-3">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-7 py-3 rounded-full bg-primary-500 text-background-50 text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
          >
            Pandabuy Sheet
            <i className="ri-arrow-right-line text-base"></i>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-7 py-3 rounded-full border border-background-50/30 text-background-50 text-sm hover:bg-background-50/10 transition-all duration-300 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
          >
            Buy It Now
            <i className="ri-shopping-bag-line text-base"></i>
          </a>
        </div>

        <div className="mt-16 hidden md:flex items-center gap-8">
          <div className="flex items-center gap-2">
            <i className="ri-checkbox-circle-line text-primary-300 text-sm"></i>
            <span className="text-xs text-background-50/70">Updated Daily</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-checkbox-circle-line text-primary-300 text-sm"></i>
            <span className="text-xs text-background-50/70">Curated Lists</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-checkbox-circle-line text-primary-300 text-sm"></i>
            <span className="text-xs text-background-50/70">Fast Access</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-checkbox-circle-line text-primary-300 text-sm"></i>
            <span className="text-xs text-background-50/70">No Noise</span>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}